import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldValidationType, DATE_OPTIONS, LottoDetails, LottoFacade } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-lotto-purchase-confirmation-v2',
  standalone: true,
  imports: [CommonModule, FGBSharedModule, PipesModule, DirectivesModule],
  templateUrl: './lotto-purchase-confirmation-v2.component.html',
})
export class LottoPurchaseConfirmationV2Component {
  @Input() lottoItem: LottoDetails;
  @Input() customFields: any[] = [];
  @Input() quantity: number;

  readonly CustomFieldType = CustomFieldValidationType;
  readonly dateOptions = inject(DATE_OPTIONS);
  readonly modal = inject(NgbActiveModal);
  private readonly lottoFacade = inject(LottoFacade);

  enter(): void {
    this.lottoFacade.enterLotto({ lotto: this.lottoItem, entries: this.quantity, customFields: this.customFields });
    this.modal.close();
  }
}
